var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('date-time-with-note',{attrs:{"details":_vm.details,"comment":_vm.comment,"type":"punch-out"}})}
var staticRenderFns = []

export { render, staticRenderFns }